// Returns the color map for the outfalls
export const getOutfallColor = (value, stormMode, overflowData, LIDMode) => {
    if (stormMode && overflowData) {
        // Define a color scheme based on value ranges
        if (value === 0) return '#666';  // original light yellow
        if (value < 10) return '#a67c52';  // Starker difference
        if (value < 100) return '#b78f6c';  // 
        if (value < 1000) return '#aa775b';  // 
        if (value < 5000) return '#9d5f4a';  // 
        if (value < 10000) return '#A52A2A';  // Red-Brown
        return '#8B0000';  // Dark Red-Brown for the really big overflows 
    } else {
        return '#bcad8f'; // Default color for outfalls
    }
};

// Original brushed color = #67ea04
const BRUSHED_SUBCATCHMENTS_COLOR = '#67ea04';

// Returns the color map for the subcatchments layer based on the selected color scheme
export const getColorLayer = (colorScheme, selectedFeatureID, LIDMode, LIDContent, devPlanContent, brushedSubcatchments = new Set()) => {
    //console.log("Getting color layer =====")
    // Defines the underlying opacity of each subcatchment
    const baseLayer = {
        id: 'subcatchments',
        type: 'fill',
        paint: {
            'fill-color': [],
            'fill-antialias': true,
            'fill-opacity': [
                'case',
                ['==', ['get', 'NAME'], selectedFeatureID],
                0.9, // Higher opacity for the selected subcatchment
                0.3  // Lower opacity for others
            ],
        },
    };

    /**
     * Configures the 'fill-color' property of the base layer
     * based on the selected color scheme.
     *
     * Defaults to white for default/unrecognized color scheme
     */
    switch (colorScheme) {
        case 'percent_impervious':
            baseLayer.paint['fill-color'] = [
                'case',
                ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments) ]],
                BRUSHED_SUBCATCHMENTS_COLOR, // Green for highlighted (brushed) subcatchments
              [
                  'interpolate',
                  ['linear'],
                  ['get', 'IMPERV'],
                  0, '#008000',
                  20, '#66A266',
                  40, '#B3CDB3',
                  50, '#FFFFFF',
                  60, '#D9BFB3',
                  80, '#A66F66',
                  100, '#663300'
              ]

            ];

            break;

        case 'elevation':
            baseLayer.paint['fill-color'] = [
                'case',
                ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments) ]],
                BRUSHED_SUBCATCHMENTS_COLOR, // Green for highlighted (brushed) subcatchments
              [
                  'interpolate',
                  ['linear'],
                  ['get', 'WTELEV'],
                  555, '#00008B', // Dark Blue
                  565, '#0000CD', // Medium Blue
                  575, '#0000FF', // Blue
                  585, '#007FFF', // Azure
                  595, '#00FFFF', // Cyan
                  605, '#7FFF00', // Chartreuse
                  615, '#FFFF00', // Yellow
                  625, '#FF7F00', // Orange
                  635, '#FF0000', // Red
                  645, '#8B0000', // Dark Red
              ]

            ];
            break;

        case 'soil_type':
            baseLayer.paint['fill-color'] = [
                'case',
                ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments) ]],
                BRUSHED_SUBCATCHMENTS_COLOR, // Green for highlighted (brushed) subcatchments
              [
                  'match',
                  ['get', 'AQUIFER'],
                  'Clay', '#A0522D',
                  'Sand', '#FFA500',
                  'Loam034', 'violet',
                  'Loam032', '#FF4500',
                  'Loam037', 'brown',
                  /* other */ 'white'
              ],
            ];
            break;

        case 'drawdown':
            baseLayer.paint['fill-color'] = [
                'case',
                ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments) ]],
                BRUSHED_SUBCATCHMENTS_COLOR, // Green for highlighted (brushed) subcatchments
                [
                    'interpolate',
                    ['linear'],
                    ['get', 'DECAY_CONSTANT_ESTIMATE'],
                    -0.28, '#fcfdbf',
                    -0.26, '#fed698',
                    -0.24, '#feaf78',
                    -0.22, '#fb8761',
                    -0.2, '#f1605d',
                    -0.18, '#d7456c',
                    -0.16, '#b6377a',
                    -0.14, '#932b81',
                    -0.12, '#721f81',
                    -0.1, '#50127b',
                    -0.08, '#2d115f',
                    -0.06, '#0f0c2e',
                    0, '#000004',
                    // /* other */ 'white'
                ]
            ];
            break;

        case 'flooding':
            console.log("floodng layer =====")
            baseLayer.paint['fill-color'] = [
                'case',
                ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments) ]],
                BRUSHED_SUBCATCHMENTS_COLOR, // Green for highlighted (brushed) subcatchments
                [
                    'case',
                    ['!=', ['typeof', ['get', 'avgFlooding']], 'null'], // Check if avgFlooding exists
                    [
                        'interpolate',
                        ['linear'],
                        ['get', 'avgFlooding'],
                        0, '#008000',  // Green for zero flooding
                        10, '#FFFF00', // Yellow for moderate flooding
                        50, '#FF0000', // Red for severe flooding
                    ],
                    'rgba(138,255,56,0.12)'
                ],
            ];
            baseLayer.paint['fill-opacity'] = [
                'case',
                ['==', ['get', 'NAME'], selectedFeatureID],
                0.9, // Highlight selected subcatchment
                0.5, // Default opacity for others
            ];
            break;

        case 'flooding_vs':
            baseLayer.paint['fill-color'] = [
                'interpolate',
                ['linear'],
                ['get', 'avgFlooding'],
                -40, '#008000',  // Green for zero flooding
                0, '#FFFF00', // Yellow for moderate flooding
                50, '#FF0000', // Red for severe flooding
            ];
            baseLayer.paint['fill-opacity'] = [
                'case',
                ['==', ['get', 'NAME'], selectedFeatureID],
                0.9, // Highlight selected subcatchment
                0.5, // Default opacity for others
            ];
            break;


        case 'compare_flooding':
            baseLayer.type = 'fill-extrusion'; // 3D effect

            baseLayer.paint = {
                'fill-extrusion-color': [
                    'interpolate',
                    ['linear'],
                    ['coalesce', ['get', 'avgFlooding'], 0],
                        -100, '#08306b',
                        -50, '#08519c',
                        -10, '#6baed6',
                            -1,  '#c6dbef',
                            0,  '#333333',
                        0.01, '#fef9d9',
                        0.05, '#fee391',
                            1,  '#fec44f',
                            10,  '#fb6a4a',
                            50,  '#de2d26',
                        100,  '#a50f15'
                ],
                'fill-extrusion-height': [
                    'interpolate',
                    ['exponential', 0.5],
                    ['coalesce', ['get', 'avgFlooding'], 0],
                    -100, -1000,
                    -50, -700,
                    -10, -300,
                    -1, -100,
                    0,    0,
                    0.01,   50,
                    0.05,  100,
                    1,  300,
                    10,  600,
                    50,  900,
                    100, 1200
                ],
                'fill-extrusion-base': 0,
            };
            break;


        case 'basementFlooding':
            baseLayer.paint['fill-color'] = [
                'case',
                ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments) ]],
                BRUSHED_SUBCATCHMENTS_COLOR, // Green for highlighted (brushed) subcatchments
              [
                  'match',
                  ["to-string", ['get', 'basement_flooding']],
                  'true', '#FF0000',  // Red for True (flooded basement)
                  'false', 'rgba(138,255,56,0.12)', // Grey for False (non flooded basement)
                  'rgba(138,255,56,0.12)'         // Default white if data is missing
              ]

            ];
            break;

        case 'standard':
            baseLayer.paint['fill-color'] = [
                'case',
                ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments) ]],
                BRUSHED_SUBCATCHMENTS_COLOR, // Green for highlighted (brushed) subcatchments
                '#ccc' // Default grey for other subcatchments
            ];
            break;


        default: // Set default subcatchment color as white
            baseLayer.paint['fill-color'] = '#ffffff';
    }

    return baseLayer;
};



// Must enforce a non-null devPlanContent when using this
export const getLIDLayer = (colorScheme, selectedFeatureID, LIDMode, LIDContent, devPlanContent) => {
    return {
        id: 'LID',
        type: 'fill-extrusion',
        filter: ['has', ['get', 'NAME'], ['literal', devPlanContent]],
        paint: {
            // Get the `fill-extrusion-color` from the source `color` property.
            'fill-extrusion-color': [
                'case',
                ['==', ['get', 'NAME'], selectedFeatureID],
                'rgba(111,255,0,0.82)', // Highlight selected subcatchment
                'rgba(111,255,0,0.45)', // Default opacity for others
            ],

            'fill-extrusion-opacity': 0.80,

            'fill-extrusion-height-transition': {
                duration: 500,
                delay: 0,
            },
            // Get `fill-extrusion-height` from the source `height` property.
            // Linear from 100 to 1000 based on percentage of coverage.

            'fill-extrusion-height': 500,

        }
    };
};


export const getSelectedFeatureBorder = (colorScheme, selectedFeatureID) => {
    return {
        id: 'selectedFeatureBorder',
        filter: ['==', ['get', 'NAME'], selectedFeatureID],
        type: 'fill-extrusion',
        paint: {
            // Get the `fill-extrusion-color` from the source `color` property.
            'fill-extrusion-color': '#FFFFFF',

            'fill-extrusion-opacity': 0.5,
            // Get `fill-extrusion-height` from the source `height` property.
            'fill-extrusion-height': 5,

        }
    };
};

export const getBrushedSubcatchLayer = (brushedSubcatchments) => {
    return {
        id: 'brushedSubcatchments',
        type: 'fill',
        filter: ['in', ['get', 'NAME'], ['literal', Array.from(brushedSubcatchments)]],
        paint: {
            'fill-pattern': 'brushPattern',
            'fill-opacity': .7,
            'fill-outline-color': "#b1d39e",
            'fill-outline-width': 0
        }
    };
};


//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////




export const getColorLayer_compareRes = (colorScheme, selectedFeatureID, LIDMode, LIDContent, beforeSubcatchment, afterSubcatchment) => {
    return {
        id: 'subcatchments',
        type: 'fill',
        paint: {
            'fill-color': [
                'case',
                ['==', ['get', 'NAME'], beforeSubcatchment], BRUSHED_SUBCATCHMENTS_COLOR, // Green for beforeSubcatchment
                ['==', ['get', 'NAME'], afterSubcatchment], '#0477ea', // Blue for afterSubcatchment
                '#666' // Default grey for all other subcatchments
            ],
            'fill-opacity': [
                'case',
                ['==', ['get', 'NAME'], beforeSubcatchment], 0.8,
                ['==', ['get', 'NAME'], afterSubcatchment], 0.8,
                0.3
            ],
        },
    };
};


export const getLIDLayer_compareRes = (colorScheme, selectedFeatureID, LIDMode, LIDContent, beforeSubcatchment, afterSubcatchment) => {
    return {
        id: 'LID',
        type: 'fill-extrusion',
        filter: ['any', ['==', ['get', 'NAME'], beforeSubcatchment], ['==', ['get', 'NAME'], afterSubcatchment]],

        paint: {
            'fill-extrusion-color': [
                'case',
                ['==', ['get', 'NAME'], beforeSubcatchment], 'rgba(103, 234, 4, 0.82)', // Green
                ['==', ['get', 'NAME'], afterSubcatchment], 'rgba(4, 119, 234, 0.82)', // Blue
                'rgba(111, 255, 0, 0.45)' // Default color
            ],
            'fill-extrusion-opacity': 0.75,
            'fill-extrusion-height': 500,
        }
    };
};


export const getSelectedFeatureBorder_compareRes = (colorScheme, selectedFeatureID, LIDMode, LIDContent, beforeSubcatchment, afterSubcatchment) => {
    return {
        id: 'selectedFeatureBorder',
        type: 'line',
        filter: ['any', ['==', ['get', 'NAME'], beforeSubcatchment], ['==', ['get', 'NAME'], afterSubcatchment]],
        paint: {
            'line-color': [
                'case',
                ['==', ['get', 'NAME'], beforeSubcatchment], '#FFFFFF', // White border for beforeSubcatchment
                ['==', ['get', 'NAME'], afterSubcatchment], '#00FFFF', // Cyan border for afterSubcatchment
                '#FFFFFF' // Default white for unmatched
            ],
            'line-width': 2,
        }
    };
};
